<template>
  <div style="width: fit-content">
    <div style="display: flex">
      <template v-for="(upElementBlocks, index) in upElementBlocksList">
        <div v-if="upElementBlocks.length > 0" :key="index" class="section form-column" :style="{width: upElementBlocks[0].width + 'px'}">
          <el-form label-width="130px" label-position="right">
            <template v-for="(item, subIndex) in upElementBlocks">
              <span :key="subIndex" class="title" style="width: 100%;">
                <el-popover
                  v-if="item.name === 'podPortInfo'"
                  placement="bottom"
                  width="200"
                  trigger="hover"
                >
                  <div class="pop-content">{{ $t('CargoMsg.Cargo_PodPortInfoPrompt') }}</div>
                  <svg-icon slot="reference" icon-class="question" style="font-size: 14px;margin-top: -3px;" />
                </el-popover>
                {{ item.title }}
              </span>
              <slot v-for="elementName in item.elementNames" :name="elementName" />
            </template>
          </el-form>
        </div>
      </template>
      <slot name="shipperConsignNotify" />
    </div>
    <div v-if="!!downElementBlock" class="section" style="width:100%">
      <span class="title">{{ downElementBlock.title }}</span>
      <div class="form-row" style="display:flex;flex-direction:row;">
        <el-form :inline="true" label-width="160px" label-position="right">
          <slot v-for="elementName in downElementBlock.elementNames" :name="elementName" />
        </el-form>
      </div>
    </div>
    <slot name="ediReceipt" />
    <slot name="ediReceiptCommon" />
  </div>
</template>

<script>
export default {
  name: 'TabVesselEqUICustomLayout',
  props: {
    elementBlocks: { type: Array, required: true }
  },
  computed: {
    upElementBlocksList() {
      const result = []
      for (let i = 1; i <= 4; ++i) {
        result.push(this.elementBlocks.filter(p => p.position === i && !p.hide))
      }
      return result
    },
    downElementBlock() {
      return this.elementBlocks.find(p => p.position === 5 && !p.hide)
    }
  }
}
</script>
